<script setup>
defineProps({
  lookup: Object
});
</script>

<template>
  <table class="w-full table-fixed">
    <thead>
      <tr>
        <th class="w-2/12 pb-3 text-left">
          {{ $t('lookup.partials.dns.card_detail_srv.rdtype') }}
        </th>
        <th class="w-1/12 pb-3 text-left">TTL</th>
        <th class="pb-3 text-left">
          {{ $t('lookup.partials.dns.card_detail_srv.priority') }}
        </th>
        <th class="pb-3 text-left">
          {{ $t('lookup.partials.dns.card_detail_srv.weight') }}
        </th>
        <th class="pb-3 text-left">
          {{ $t('lookup.partials.dns.card_detail_srv.port') }}
        </th>
        <th class="pb-3 text-left">
          {{ $t('lookup.partials.dns.card_detail_srv.target') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(entry, i) in lookup.entries" :key="i">
        <td>PTR</td>
        <td>{{ lookup.ttl }}</td>
        <td>{{ entry.priority }}</td>
        <td>{{ entry.weight }}</td>
        <td>{{ entry.port }}</td>
        <td>{{ entry.target }}</td>
      </tr>
    </tbody>
  </table>
</template>
